@let items = selectedItems() ?? [];
@let item = currentItem();

@let singleSelection = items.length === 1;
@let emptySelection = items.length === 0;
@let multipleSelection = items.length > 1;

<div class="right-panel">
  <evc-button
    class="close-btn"
    size="small"
    type="primary"
    frame="none"
    icon="close"
    (click)="close()" />
  @if (singleSelection) {
    <div class="header">
      <drive-file-item
        class="header__title"
        [file]="selectedItems()[0]"
        size="lg" />

      @if (item.isLocked) {
        <evc-status-indicator
          class="header__tag"
          [text]="'list.menu.inUse' | translate"
          status="warn" />
      }
      @if (item.deletedAt) {
        <evc-status-indicator
          class="header__tag"
          [text]="'list.menu.deleted' | translate"
          status="warn" />
      }
    </div>
    <div class="content">
      @for (group of metadatas() | keyvalue: metadataGroupOrder; track group.key) {
        @if (group.value.length > 0) {
          <section [attr.class]="`section section__${group.key}`">
            <h2 class="section__title">{{ `info.${group.key}.section` | translate }}</h2>
            <ol class="list">
              @for (meta of group.value; track meta.name) {
                <li class="list__item meta">
                  <evc-icon
                    class="meta__icon"
                    [icon]="meta.icon"
                    size="sm" />
                  <div class="meta__content">
                    <h3 class="meta__name">{{ meta.name }}:</h3>
                    <p class="meta__value">{{ meta.value }}</p>
                  </div>
                </li>
              }
            </ol>
          </section>
        }
      }
    </div>
  } @else {
    <div class="placeholder">
      @let data =
        emptySelection
          ? {
              src: '/assets/images/ill-nothing-selected-gray.png',
              alt: ('error.noImageAltText.noItemSelected' | translate),
              title: ('list.menu.SelectToSeeDetails' | translate),
            }
          : {
              src: '/assets/images/ill-two-files-selected-light.png',
              alt: ('error.noImageAltText.tooManyItemsSelected' | translate),
              title: selectionLabel(),
            };

      <img
        class="placeholder__image"
        [src]="data.src"
        [alt]="data.alt"
        width="256"
        height="256" />
      {{ data.title }}
    </div>
  }
</div>
